const ACTIVE_WORKSPACE_STORAGE_KEY = 'moy-gorod:active-workspace';
const TKO_PRIMORYE_HOST = 'tko.primorye.moy-gorod.su';
const TKO_PRIMORYE_WORKSPACE = 'vertical:waste_removal';

export const normalizeWorkspaceKey = (value: string | null | undefined): string | null => {
  const normalized = String(value || '').trim().toLowerCase();
  return /^(?:platform|tenant|region|vertical|uk):[a-z0-9][a-z0-9:_-]{0,127}$/.test(normalized)
    ? normalized
    : null;
};

export function readActiveWorkspace(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = normalizeWorkspaceKey(window.sessionStorage?.getItem(ACTIVE_WORKSPACE_STORAGE_KEY));
    if (stored) return stored;
    if (window.location.hostname.toLowerCase() === TKO_PRIMORYE_HOST) {
      return TKO_PRIMORYE_WORKSPACE;
    }
    return null;
  } catch {
    return null;
  }
}

export function activeWorkspaceManagementCompanyId(
  workspaceKey: string | null = readActiveWorkspace(),
): number | null {
  const match = /^uk:[a-z0-9][a-z0-9-]{0,63}:([1-9][0-9]*)$/.exec(workspaceKey ?? '');
  if (!match) return null;
  const value = Number(match[1]);
  return Number.isSafeInteger(value) ? value : null;
}

export function selectActiveWorkspace(workspaceKey: string): string | null {
  const normalized = normalizeWorkspaceKey(workspaceKey);
  if (typeof window === 'undefined' || !normalized) return null;
  try {
    window.sessionStorage?.setItem(ACTIVE_WORKSPACE_STORAGE_KEY, normalized);
  } catch {
    return null;
  }
  window.dispatchEvent(new CustomEvent('active_workspace_changed', { detail: normalized }));
  return normalized;
}

export function clearActiveWorkspace(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage?.removeItem(ACTIVE_WORKSPACE_STORAGE_KEY);
  } catch {
    // Hardened browser storage may be unavailable.
  }
  window.dispatchEvent(new CustomEvent('active_workspace_changed', { detail: null }));
}
